import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PRACTITIONER } from "@/lib/content";

export default function Practitioner({ onBookNow }) {
  return (
    <section id="practitioner" className="py-20 sm:py-28">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-12">
          <div className="eyebrow mb-3">Meet your therapist</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-[#0B302F] tracking-tight leading-tight">
            The journey behind <em className="not-italic text-[#D5B876]"><i>Bloom & Heal</i></em>
          </h2>
        </div>

        <div className="flex flex-col items-center mb-10">
          <div className="relative">
            <div className="absolute -inset-2 bg-[#E7D5A8]/50 rounded-full blur-xl" />
            <img
              src={PRACTITIONER.photo}
              alt={PRACTITIONER.name}
              className="relative h-28 w-28 sm:h-32 sm:w-32 rounded-full object-cover ring-2 ring-[#D5B876]/60 shadow-md"
              data-testid="practitioner-thumb"
            />
          </div>
          <div className="mt-5 text-center">
            <div className="font-serif text-2xl sm:text-3xl text-[#0B302F]">
              {PRACTITIONER.name}
            </div>
            <div className="mt-1.5 eyebrow text-[#2A5C5A]">{PRACTITIONER.title}</div>
            {PRACTITIONER.role && (
              <div className="mt-1 eyebrow italic normal-case tracking-[0.18em] text-[#2A5C5A]">
                {PRACTITIONER.role}
              </div>
            )}
          </div>
        </div>

        <div className="botanical-divider max-w-xs mx-auto" />

        <article className="mt-10 prose-lg max-w-2xl mx-auto text-[#0B302F]/85 leading-[1.85] font-serif text-xl sm:text-2xl">
          {PRACTITIONER.bio.map((p, i) => (
            <p
              key={i}
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: p }}
            />
          ))}
        </article>

        <div className="mt-10 flex justify-center">
          <Button
            onClick={onBookNow}
            data-testid="practitioner-book-now"
            size="lg"
            className="rounded-full bg-[#0B302F] text-[#FDFBF7] hover:bg-[#2A5C5A] px-7 h-12 text-xs tracking-[0.22em] uppercase"
          >
            Book a Session <ArrowRight className="ml-2 h-4 w-4" strokeWidth={1.5} />
          </Button>
        </div>
      </div>
    </section>
  );
}
